import React, { Component } from "react";
import "./partnersFilter.scss";
import { debounce } from "lodash";

import { env } from "../../../../shared/environment";

import axios from "axios";

import Dropdown from "../../../../shared/components/dropdown";
// import i_search from "../../../../shared/assets/images/ic_search.png";
import search from "../../../../shared/assets/images/partners/search.svg";

class PartnersFilter extends Component {
    urlPrefix = env.baseUrl;
    isResetFilterValue = false;
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            cities: [],
            periods: [],
            partnersName: "",
            isFiltered: false
        };
    }

    componentDidMount() {
        this.onSelect = this.onSelect.bind(this);
        this.onPartnersNameChange = this.onPartnersNameChange.bind(this);
        this.onSearchHandler = this.onSearchHandler.bind(this);
        this.cleanFilter = this.cleanFilter.bind(this);
        this.search = this.search.bind(this);

        var self = this;

        axios
            .all([
                axios.get(`${this.urlPrefix}public/categories`),
                axios.get(`${this.urlPrefix}public/cities`),
                axios.get(`${this.urlPrefix}public/periodspublic`)
            ])
            .then(
                axios.spread(function (categories, cities, periods) {
                const filteredCategories = categories.data.payload.filter(c=>c.name.slice(0,1)!=='#')
                const hashtags = categories.data.payload.filter(c=>c.name.slice(0,1)==='#')
                    self.setState({
                        categories: [...filteredCategories, ...hashtags],
                        cities: cities.data.payload,
                        periods: periods.data.payload
                    });
                })
            )
            .catch(error => console.log(error));

        const defaultName =
            this.props && this.props.defaultValues && this.props.defaultValues.name
                ? this.props.defaultValues.name
                : null;

        if (defaultName) {
            this.setState({
                partnersName: defaultName
            });
        }

        if (this.props && this.props.isFiltered) {
            this.setState({
                isFiltered: true
            });
        }
    }

    onSelect(event) {
        this.props.onFilter(event);
        this.setState({
            isFiltered: true
        });
        this.isResetFilterValue = false;
    }

    cleanFilter() {
        this.props.onFilter("clean");
        this.setState({
            isFiltered: false
        });
        this.isResetFilterValue = true;

        this.setState({
            partnersName: ""
        });
    }

    onPartnersNameChange(event) {
        this.setState({
            partnersName: event.target.value
        });

        let params = {
            key: "partnersName",
            value: event.target.value
        };

        this.search(params);

        this.setState({
            isFiltered: true
        });
    }

    search = debounce(params => {
        this.props.onFilter(params);
    }, 400);

    onSearchHandler() {
        let params = {
            key: "partnersName",
            value: this.state.partnersName
        };

        this.props.onFilter(params);
    }

    render() {
        const allCities = {
            id: 0,
            name: "Все города"
        };

        const allCategories = {
            id: 0,
            name: "Все категории"
        };

        const allParams = {
            id: 0,
            name: "Все периоды"
        };

        const categoriesOptions = [].concat(allCategories, this.state.categories);
        const citiesOptions = [].concat(allCities, this.state.cities);
        const periodsOptions = [].concat(allParams, this.state.periods);
        const typeOptions = [
            { id: 0, name: "Тип" },
            { id: 1, name: "Салом" },
            { id: 2, name: "Стандарт" }
        ];

        const cityParams = {
            label: "Все города",
            iconType: "city",
            theme: "light",
            options: citiesOptions
        };

        const categoryParams = {
            label: "Все категории",
            iconType: "category",
            theme: "light",
            options: categoriesOptions
        };

        const periods = periodsOptions.filter(
            (val, index, arr) => val || val.name === "Все периоды"
        );

        // eslint-disable-next-line no-unused-vars
        const periodParams = {
            label: "Срок",
            iconType: "period",
            theme: "light",
            options: periods
        };

        // eslint-disable-next-line no-unused-vars
        const typeParams = {
            label: "Тип",
            iconType: "type",
            theme: "light",
            options: typeOptions
        };

        const defaultCity =
            this.props && this.props.defaultValues && this.props.defaultValues.cityID
                ? this.props.defaultValues.cityID
                : 0;
        const defaultCategory =
            this.props &&
                this.props.defaultValues &&
                this.props.defaultValues.categoryID
                ? this.props.defaultValues.categoryID
                : 0;
        // eslint-disable-next-line no-unused-vars
        const defaultPeriodID =
            this.props &&
                this.props.defaultValues &&
                this.props.defaultValues.periodID
                ? this.props.defaultValues.periodID
                : null;
        // eslint-disable-next-line no-unused-vars
        const defaultTypeID =
            this.props &&
                this.props.defaultValues &&
                this.props.defaultValues.conditionsTypeID
                ? this.props.defaultValues.conditionsTypeID
                : null;

        return (
            <div className="partners-filter">
                <div className="row">
                    <div className="col-md-4 col-lg-4 mb-2">
                        <Dropdown
                            itemKey={"category"}
                            params={categoryParams}
                            onSelect={this.onSelect}
                            defaultValue={defaultCategory}
                            isResetFilterValue={this.isResetFilterValue}
                        />
                    </div>
                    <div className="col-md-4 col-lg-3 mb-2">
                        <Dropdown
                            itemKey={"city"}
                            params={cityParams}
                            onSelect={this.onSelect}
                            defaultValue={defaultCity}
                            isResetFilterValue={this.isResetFilterValue}
                        />
                    </div>
                    <div className="col-md-4 col-lg-5 mb-2 d-flex ctm-input-search">
                        <img src={search} className="d-none d-md-block" alt="search" />
                        <input placeholder="Найти"
                            value={this.state.partnersName}
                            onChange={this.onPartnersNameChange}
                            className="w-100 h-100" />
                        <img src={search} className="d-md-none d-block" alt="search" />
                    </div>
                </div>
                {this.state.isFiltered ? (
                    <div className="row">
                        <div className="text-center m-auto clean-filter">
                            <i className="fa fa-times"></i>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a onClick={this.cleanFilter} className="link-behaviour">
                                Очистить фильтр
                            </a>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default PartnersFilter;
